// Copyright 2019 Sorama B.V.

import { Disposable } from "aurelia-binding";
import { IAspectItem } from "./IAspectItem";

export class AspectItemElement {
    public element: HTMLElement;
    public viewModel: IAspectItem;
}

export class AspectItemsCatalog {
    private container: AspectItemElement[] = [];

    public subscribe(item: AspectItemElement): Disposable {
        this.container.push(item);

        return <Disposable>{
            dispose: () => {
                const idx = this.container.findIndex((x) => x == item);
                if (idx > -1) this.container.splice(idx);
            },
        };
    }

    public getItem(element: Element): AspectItemElement {
        return this.container.find((x) => {
            return x.element == element;
        });
    }
}
